
//	token 数据
const state = {
    imagesSrc: [],
}

//	同步
const mutations = {
    setImagesSrc(state, imageData){
        state.imagesSrc = [...state.imagesSrc,imageData].reduce((cur,next)=>cur.filter(it=>it.id==next.id).length==0?[...cur,next]:cur,[]);
    },
    removeImagesSrc(state,id){
        state.imagesSrc=state.imagesSrc.reduce((cur,next)=>next.id!=id?[...cur,next]:cur,[]);
    }

}

//	异步，外部保存数据调用此内部方法
const actions = {
    setImageSrcs({
                    commit
                }, imageData) {
        commit("setImagesSrc", imageData);
    },
}

//	获取
const getters = {
    setImageSrcs(state) {
        return state.imagesSrc;
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
